var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleFit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1522 10.5865C22.9428 8.79585 22.9428 5.89262 21.1522 4.10197C19.3615 2.31131 16.4583 2.31131 14.6676 4.10197L6.07835 12.6913L12.5629 19.1758L21.1522 10.5865Z",
    stroke: "#039BE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8993 8.441C19.5044 7.83581 19.5044 6.85462 18.8993 6.24943C18.2941 5.64424 17.3129 5.64425 16.7077 6.24943L10.35 12.6072L12.5415 14.7987L18.8993 8.441Z",
    stroke: "#039BE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5645 7.75668L8.7005 6.02037C7.95166 5.32281 6.78493 5.34349 6.06128 6.06714V6.06714C5.32019 6.80823 5.31893 8.00937 6.05846 8.75201L7.75644 10.4571",
    stroke: "#039BE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01139 10.6197C2.18648 8.79481 2.18649 5.83605 4.01139 4.01115C5.83629 2.18624 8.79505 2.18624 10.62 4.01114L12.6396 6.03082L6.03106 12.6394L4.01139 10.6197Z",
    stroke: "#039BE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6808 10.2758L19.867 12.4622",
    stroke: "#039BE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleFit);
export default __webpack_public_path__ + "static/media/google-fit.12fdcbb5.svg";
export { ForwardRef as ReactComponent };